import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { addBrand, getBrandList, updateBrand } from "./useBrands";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

interface BrandParams {
    start?: number;
    length?: number;
    Orgunitid?: number | null;
    search?: string;
  }

export const useGetBrnadList = ({enable = false,params}:{enable:boolean,params:BrandParams})=>{
    return useQuery({
        queryKey:['GET_BRAND_LIST',params],
        queryFn:()=>getBrandList(params),
        enabled:enable,
        retry:false
    })   
}

interface ReqBody{
        BrandName: string,
        BrandCode: string,
        BrandRate: number,
        MinValue: number,
        Orgunitid: number | null
        
}

export const useAddBrand = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:({ReqBody}:{ReqBody:ReqBody})=>addBrand({ReqBody}),
        onSuccess:()=>{
            showToast.success('Brand is Added Successfully')
            queryClient.invalidateQueries({queryKey:['GET_BRAND_LIST']})
        },
        onError:(error:any)=>{
          console.log(`Failed to add ${error.message}`);
          showToast.error(`Failed to add the Brand. Please try agin`);
        }
    })
}
 
interface updateBodyInterface{
   BrandName : string ,
  BrandCode: string,
  BrandRate: number,
  MinValue: number,
  Orgunitid: number
}

export const useUpdate  =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn: ({ ReqBody, id }:{ReqBody:updateBodyInterface,id:number}) => updateBrand({ ReqBody, id }),
    onSuccess:()=>{
        showToast.success('Updated Successfully')
        queryClient.invalidateQueries({queryKey:['GET_BRAND_LIST']});
    },
    onError:(error:any)=>{
        console.log(`Failed to update ${error.message}`);
        showToast.error(`failed ot update Brand`);
    } 
})
}

